import { ReportBASalesListComponent } from './sales-list.component';

export default ReportBASalesListComponent;
